import * as React from 'react';

import { Spinner } from '@base/components/ui';
import { getTranslation } from '@base/utils';

import * as s from '@ui/PreloaderScreen/PreloaderScreen.scss';

import { PaymentTitle } from './PaymentTitle';

export const PaymentWait = () => {
	const paymentTranslation = getTranslation('pages.PaymentResult');

	return (
		<div>
			<PaymentTitle>{paymentTranslation('wait')}</PaymentTitle>
			<Spinner className={s.spinner}/>
		</div>
	);
};
